export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_2560000-3afe75f0721d924d16f55a9d677cb221.avif";